import type { ChipDefinition, ChipFamily } from '@/types/hid8051';
import { N76E003 } from './nuvoton/n76e003';
import { MS51FB9AE } from './nuvoton/ms51fb9ae';
import { SN8F5708 } from './sonix/sn8f5708';

// All registered 8051 chip definitions
const CHIPS: ChipDefinition[] = [N76E003, MS51FB9AE, SN8F5708];

/**
 * 8051 Chip Database — identifies chips by device ID.
 * Separate from the ARM TargetDB which uses SWD IDCODE.
 */
export class ChipDB {
  /**
   * Identify a chip by its device ID.
   * Returns the matching ChipDefinition or undefined.
   */
  static identify(deviceId: number): ChipDefinition | undefined {
    return CHIPS.find((chip) => {
      if (chip.deviceIdMask) {
        return (deviceId & chip.deviceIdMask) === (chip.deviceId & chip.deviceIdMask);
      }
      return chip.deviceId === deviceId;
    });
  }

  /**
   * Get a chip definition by name (case-insensitive).
   */
  static getByName(name: string): ChipDefinition | undefined {
    const lower = name.toLowerCase();
    return CHIPS.find((chip) => chip.name.toLowerCase() === lower);
  }

  /**
   * Get all chips for a given family.
   */
  static getByFamily(family: ChipFamily): ChipDefinition[] {
    return CHIPS.filter((chip) => chip.family === family);
  }

  /**
   * Get all registered chip definitions.
   */
  static getAll(): ChipDefinition[] {
    return [...CHIPS];
  }
}
